import { Form, Button} from 'react-bootstrap';
import React, { Fragment, useState, useEffect } from "react";
import Link from 'next/link'
import { useRouter } from 'next/router'
import NotAMember  from './NotAMember';
import { parseFormData } from '@group-devs/yfp7-global-modules/utils/general'
import Spinner from 'react-bootstrap/Spinner'
import Authenticator from '@group-devs/yfp7-authenticator'

const ArticleLoginForm = (props) => {
    const router = useRouter()
    const asPath = router.asPath

    const [isJoinTag, setJoinTag] = useState(true);
    const [errorMessage, setErrorMessage] = useState('')
    const [loader, setLoader] = useState(false)
    const [validationUrl, setValidationUrl] = useState('')
    const [currentUrl, setCurrentUrl] = useState('');

    let curProps = asPath && asPath == "/file-cabinet" ? props.props.props.props : props.props.props.props.props
    
    useEffect(() => {

        let url, host;
        host = new URL(window.location.href)
        url  = new URL(`${host.protocol}//${host.host}/api/authenticate`)
        url.searchParams.append('continue', '/home')
        setValidationUrl(url)
        setCurrentUrl(window.location.href)
    }, [])


    async function submitLogin(event) {
        event.preventDefault()

        setErrorMessage('')
        setLoader(true)

        let prePostData = {
            csrf: curProps.metadata.csrf,
            websiteId: curProps.site.websiteId
        }

        let postData = new FormData(event.target)
        let parseData = parseFormData(postData)
        postData = { ...parseData, ...prePostData }

        const password = parseData.password;
        const email = parseData.email;

        if(password == ""){
            setErrorMessage('All fields are required');
            setLoader(false)

        }

        if(email == ""){
            setErrorMessage('All fields are required');
            setLoader(false)

        }

        function handleSuccess(data) {
            if (data.token === null)
                setErrorMessage(data.message)
            setLoader(false)
            return data
        }

        if(password != "" && email != ""){

            const _response = await fetch(validationUrl, {
                method: 'POST',
                headers: Authenticator.getJSONHeaders(),
                body: JSON.stringify(postData)
            })
            .then((response) => { return response.json() })
            .then((data) => handleSuccess(data)).catch((error) => {
                console.log(error)
            })

            if (typeof JSON.parse(_response) === 'object'){
                let responseObj = JSON.parse(_response)
                if (responseObj.code === 200) {
                    if (typeof window !== 'undefined') {

                        if(asPath && asPath == "/file-cabinet"){
                            window.location.reload();
                        }else{
                            window.location.href = currentUrl
                        }
                        
                    }
                }else{
                    let html = responseObj.message
                    let cleanText = html.replace(/<\/?[^>]+(>|$)/g, "");

                
                    setErrorMessage(cleanText);
                }
            }

        }
    }



    return (
        <div className="section-login-form">
            <Fragment>
            {isJoinTag ? (
              <div>
              <p><strong>Member Login</strong></p>
              {errorMessage ? <div className="alert alert-danger mb-3 h7">{errorMessage}</div> : ''}
                <Form onSubmit={submitLogin}>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Control type="email" name="email" placeholder="Enter email" />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Control type="password" name="password" placeholder="Password" />
                  </Form.Group>
                  <Button className="btn-login m-auto d-block py-3 border-0 rounded-0" variant="primary" type="submit">
                    {
                      (loader) ?
                          <Spinner animation="border" role="status">
                              <span className="sr-only"></span>
                          </Spinner>
                      :
                          <h4>Login</h4>
                    }
                  </Button>
                  <br />
                  <Link className="text-blue" href="https:/account.yourwellnessproject.com/user/recovery" passHref target="_blank">Forgot Password</Link>
                  <br /><br />
                  <a className="font-weight-bold text-blue" onClick={() => setJoinTag(false)}>Not a Member yet?</a><br />
                  <a className="text-blue" onClick={() => setJoinTag(false)}>Create Account</a>
                </Form>
                </div>
            ) : (
                <NotAMember props={props} />
            )}
            
            </Fragment>
            
        <style jsx global>{`
        

          .section-login-form .form-control{
            font-size:0.9rem;
          }

          .btn-login{
            background-color: #43a649!important;
            width:100%;
            max-width:450px;
          }
          
          .btn-login:hover,
          .btn-login:active,
          .btn-login:focus{
              text-decoration: none;
              background-color: #5ebe64!important;
              border:none!important;
          }

          .btn-login h4{
            text-align:center;
          }
          
          .section-login-form{
            max-width:455px!important;
          }

          .section-login-form a{
            color: #1051B9!important;
          }

        `}</style>

        </div>
    );
};

export default ArticleLoginForm;